:host {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: 100%;
}

.push-body {
  &--menu {
    display: none;
  }
}

.push-body,
.push-body--content {
  height: 100%;
}

.wrapper {
  flex-direction: column;
  height: 100%;

  #complianceLearnMoreButton {
    margin-top: var(--spacer);
  }

  #complianceLicenseLinkId {
    text-decoration: underline;
  }

  &.is-loading {
    .company-selector-loader {
      display: block;
    }

    .company-selector {
      display: none;
    }
  }

  &.is-error {
    .risk-management-header,
    .risk-management-content {
      display: none;
    }

    .loading-error {
      display: block;
    }
  }
}

.full-height-cell {
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
  pointer-events: all;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.company-selector-loader {
  display: none;
  width: 160px;
}
.loader {
  margin-top: calc(2 * var(--spacer));

  .smartview-loader {
    padding-right: calc(2 * var(--spacer));
    padding-left: calc(3 * var(--spacer));
    position: relative;

    &:last-child {
      padding-top: var(--spacer);
    }

    &:not(:first-of-type) {
      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        height: 1px;
        width: calc(100% - calc(5 * var(--spacer)));
        left: calc(3 * var(--spacer));
        background-color: var(--secondary-color-10);
      }
    }

    &:first-child {
      padding-bottom: calc(2 * var(--spacer));
    }
  }
}

.risk-management-header {
  display: flex;
  flex-direction: column;
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 2.5) calc(var(--spacer) * 3) calc(var(--spacer) * 2.5);
  height: 64px;

  &--top {
    display: flex;
    justify-content: space-between;
  }
}

.subtitle {
  color: var(--chart-300-icon-buttons);
}

.loading-error {
  display: none;
  height: auto;
  width: 500px;
  margin: auto;

  &--message {
    max-width: 310px;
    line-height: 1.25;
  }
}

.risk-management-content {
  flex-grow: 2;
  height: 100%;

  .risk-management-grid {
    height: 100%;
  }

  gz-grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}

gz-push-body-layout[resizable][isopen]::part(header) {
  margin-bottom: calc(2 * var(--spacer));
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
  text-transform: uppercase;
}

gz-push-body-layout[resizable][isopen]::part(sideNav) {
  min-width: 240px;
}

gz-push-body-layout[isopen] div[slot='push-body-sidenav'] {
  height: 100%;
}

.header-buttons {
  width: 100%;
  position: relative;
  display: flex;

  #download-report-tooltip {
    margin-left: auto;
  }
}

.compliance-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));

  &--top {
    display: flex;
    justify-content: space-between;
    line-height: 33px;
  }
}

#compliance-info-box {
  width: 100%;
}

.feedback-btn {
  margin-left: auto;
  margin-right: calc(var(--spacer) * 18);
  .icon {
    font-size: 24px;
    margin-right: calc(var(--spacer) / 2);
  }
}

.feedback-toolbar {
  gz-loader[class*='title-loader'] {
    padding: calc(var(--spacer) * 1.3) 0 calc(var(--spacer) * 2.5) calc(var(--spacer) * 2.5);
  }
}

.early-access-container {
  background-color: var(--blue-layout-101-background);
  padding: calc(var(--spacer) / 2) calc(var(--spacer) * 2);
  text-transform: uppercase;
  gz-title {
    color: var(--black-layout-700-primary);
  }
}

::part(gridInfoBox) {
  max-height: unset;
  margin-left: unset;
}

::part(gridToolbar) {
  padding-bottom: var(--spacer);
}
